import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../scss/workstream.scss';
import {
    ThemeProvider,
    Modal,
    ModalWrapper,
} from '@workboard/wobo-ui';


import styled from "styled-components"
import ReactDOM from 'react-dom';
import WsShareAddComp from '../components/wspermission/ws-share-add';
import WsAccessComp from '../components/wspermission/ws-access';

import WsPermissionServie from '../services/wsPermission.service';
// import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';


const StyledModal = styled(Modal)`
  ${ModalWrapper} { 
    width: 500px;
  }
`;


const WsPermissionModalComp = (props: any) => {
    const { t } = useTranslation();
    const wsPermissionService = new WsPermissionServie();
    const [showModal, setShowModal] = useState(true);
    const [inputValue, setInputValue] = useState(null);
    const [userList, setUserList] = useState([]);
    const [temporaryUserList, setTemporaryUserList] = useState([])
    const [teamList, setTeamList] = useState([]);
    const [options, setOptions] = useState([]);
    const [autoSelect, setautoSelect] = useState<boolean>(true);
    const [isValidation, setValidation] = useState<any>({ isSaveError: false, isAddError: false });
    const [selectAllCheck, setSelectAllCheck] = useState<boolean>(false);

    let isSubmit = false;

    useEffect(() => {

        setShowModal(true);
        if (props.userList.length > 0) {
            let userListArray = [...userList]
            props.userList.forEach(item => {
                if (item.id != props.logginUserId) {
                    userListArray.push({
                        userPic: item.picture,
                        isChecked: item.access == 1 ? true : false,
                        label: item.firstname + ' ' + item.lastname,
                        userId: item.id,
                        teamId: item.team_id ? item.team_id : "0"
                    })
                }
            })
            setUserList([...userListArray]);

            selectAllUpdate(userListArray);
        }

        if (props.teamList.length > 0) {
            setTeamList(props.teamList.map(item => {
                return {
                    teamId: item.id ? item.id : "0",
                    teamName: item.name
                }
            }));
        }
        setautoSelect(props.ws_permission === 1 || props.ws_permission ? true : false);
    }, []);

    const woboAutoCompleteCustom =()=>{
        // Adding the class to autocomplete dropdown    
        $('#user_team_list-popup').parent().addClass('ws-autocomplete-dropdown');
    }

    const handleInputChange = (e, value: any,reason) => { 

         if (reason === 'clear') {
            e.preventDefault()
            //setInputValue('')
            setInputValue(''); 
            return 
        }
        if (value) {
            value.isChecked = true;
            setInputValue(value);
        }
    }

    const wsSearchPermissionQuery = async (term) => {
        if (term.length >= 3) {
            let params = {
                term: term,
                teamId: props.teamId,
                team: true,
                fromOrg: true
            }
            setOptions(await wsPermissionService.getSerachUserList(params));
            woboAutoCompleteCustom();
        }
    } 


    const handleCloseModal = () => {
        setShowModal(false);
        ReactDOM.unmountComponentAtNode(document.getElementById('app-portal-container'));
    }
    const handleSaveModal = async () => {

        if (isSubmit)
            return false;

        //if (userList.length > 0) {
        isSubmit = true;
        let paramObj: any = {};
        if (userList.length > 0) {
            userList.forEach((value, index) => {
                let random = getRandomInteger(1000, 2000)
                paramObj["wsSelectedUser[" + value.userId + "_" + random + "][userId]"] = value.userId;
                paramObj["wsSelectedUser[" + value.userId + "_" + random + "][userAccess]"] = value.isChecked ? 1 : 0;
                paramObj["wsSelectedUser[" + value.userId + "_" + random + "][teamId]"] = value.teamId ? value.teamId : 0;
            });
        }

        paramObj["wsId"] = props.wsId;
        paramObj["user_team_list"] = '';
        paramObj["removedUsers"] = '';
        paramObj["ws_permission"] = autoSelect ? 1 : 0;

        const res = await wsPermissionService.saveWorkstreamAccess(paramObj)
        const result = JSON.parse(res.data.body)
        if (result.data.success) {
            isSubmit = false;
            setShowModal(false);
            ReactDOM.unmountComponentAtNode(document.getElementById('app-portal-container'));
            triggerLeftMenu(
                `${wbConfig.baseUrl}/activity/workstreams?id=${props.wsId}`,
                false,
                "menu-wb-workstreams"
            );
        }
        // }
        // else {
        //     if (!isValidation.isAddError)
        //         setValidation({ ...isValidation, isSaveError: true });
        // }
    }

    const getRandomInteger = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    const parseListValue = async (listValue, userListArray, teamArrayList) => {
        const result = { users: userListArray, teams: teamArrayList }
        if (listValue.teamId === 0 && listValue.value) {
                const param = {
                    teamId: parseInt(listValue.value)
                }
                const res = await wsPermissionService.getTeamUserList(param);

                const index = result.teams.findIndex(item => item.teamId === res.data.teamId)
                if (index === -1) {
                    result.teams.push({ teamId: res.data.teamId, teamName: res.data.teamName })
                }

                if (res.data.inviteeList && res.data.inviteeList.length > 0) {
                    res.data.inviteeList.forEach((item: any) => {
                        const index = result.users.findIndex(item1 => item1.userId === item.id)
                        if (index === -1) {
                            result.users.push(
                                {
                                    userPic: item.pic,
                                    isChecked: true,
                                    label: item.name + ' ' + item.lastName,
                                    userId: item.id,
                                    teamId: item.team_id
                                }
                            );
                        } else {
                            result.users[index].isChecked = true;
                        }
                    });
                }

            } else {

                let index = result.users.findIndex(item1 => item1.userId === listValue.userId)
                if (index === -1) {
                    result.users.push({
                      ...listValue,
                      isChecked: true})
                } else {
                    result.users = 
                        result.users.map((item) => {
                            if (item.userId === listValue.userId)
                                item.isChecked = true;
                            return item;
                        });
                    
                }


            }
        
            if (result.users.length > 0) {
                setValidation(prvState => ({ ...prvState, isSaveError: false }));
            }

    }

    const handleAddAccess = async () => {

        if (!temporaryUserList || temporaryUserList.length === 0) {
          if (!isValidation.isSaveError) {
                setValidation(prvState => ({ ...prvState, isAddError: true }));
            }
          return
        }

        const userListArray = [...userList];
        const teamArrayList = [...teamList];

        for (const listValue of temporaryUserList) {
          await parseListValue(listValue, userListArray, teamArrayList)
        }

        setUserList([...userListArray]);
        setTeamList([...teamArrayList]);

        setTemporaryUserList([]);
        setOptions([]);
        setValidation(prvState => ({ ...prvState, isAddError: false }));
    }

    const handleAccesChange = (id: string) => {
        updateAccessCheckbox(id);
    }

    const handleSelectAll = (e: any) => {
        setUserList(
            userList.map((item) => {
                item.isChecked = e.currentTarget.checked;
                return item;
            })
        );

        setSelectAllCheck(e.currentTarget.checked);
    }

    const updateAccessCheckbox = (id: string) => {
        if (id) {
            let userListArray = [...userList];
            userListArray.map((item) => {
                if (item.userId === id)
                    item.isChecked = !item.isChecked;
                return item;
            })
            setUserList([...userListArray]);
            selectAllUpdate(userListArray);
        }
    }

    const selectAllUpdate = (userListArray: any) => {
        if (userListArray.length > 0) {
            let checkedArrayLength = userListArray.filter(item => item.isChecked).length;
            checkedArrayLength == userListArray.length ? setSelectAllCheck(true) : setSelectAllCheck(false); {
            }
        }
    }

    const handleRemoveTeam = (id: string) => {
        if (id) {
            let teamArrayList = [...teamList];
            let userArrayList = [...userList];
            const index = teamArrayList.findIndex(item => item.teamId === id)
            let newUserArraylist = userArrayList.filter(item => {
                return item.teamId != id
            });

            if (index > -1) {
                teamArrayList.splice(index, 1);
            }

            setTeamList([...teamArrayList]);
            setUserList([...newUserArraylist]);
        }
    }

    const handleAutoSelect = () => {
        setautoSelect(currentVal => !currentVal);
    }

    const handleUpdateUserList = (list) => {
      setTemporaryUserList(list);
      if (list.length === 0) {
        setOptions([]);
      }
    }

    return (
        <ThemeProvider>
            <StyledModal
                data-testid="WSPermissionModal"
                className="modal-wspermission modal-backdrop-wspermission"
                title={t('Workstream permissions')}
                isOpen={showModal}
                submitLabel={t('Save')}
                onDismiss={handleCloseModal}
                onSubmit={handleSaveModal}
                submitOnly={true}
            >
                <div className="share-ws-section">
                    <WsShareAddComp
                        inputValue={inputValue}
                        handleInputChange={handleInputChange}
                        addAccessHandler={handleAddAccess}
                        teamId={props.teamId}
                        options={options}
                        wsSearchPermissionQuery={wsSearchPermissionQuery}
                        wsAccessList={userList}
                        isError={isValidation}
                        onUpdateWsAccessList={handleUpdateUserList}
                        value={temporaryUserList}
                    />

                    <WsAccessComp
                        wsAccessList={userList}
                        handleAccesChange={handleAccesChange}
                        handleselectAll={handleSelectAll}
                        autoSelect={autoSelect}
                        handleAutoSelect={handleAutoSelect}
                        teamList={teamList}
                        handleRemoveTeam={handleRemoveTeam}
                        selectAllCheck={selectAllCheck}
                    />
                </div>
            </StyledModal>
        </ThemeProvider>
    )
}

export default WsPermissionModalComp
